// import moment from "moment";
// import { useSelector } from "react-redux";
// import { useState, useEffect, useCallback, useRef } from "react";

// import { AuthRoutes, AppRoutes } from "./Routes";
// function App() {
//   // checking token state, rendering routes
//   const { token } = useSelector((store) => store.LoginReducer);

//   // const [events, setEvents] = useState([
//   //   "click",
//   //   "load",
//   //   "scroll",
//   //   "change",
//   //   "keydown",
//   // ]);
//   // // const logOutTime = 30; // minute

//   let timeStamp;
//   let warningInactiveInterval = useRef();
//   let startTimerInterval = useRef();

//   let timeChecker = () => {
//     startTimerInterval.current = setTimeout(
//       () => {
//         let storedTimeStamp = sessionStorage.getItem("lastTimeStamp");
//         warningInactive(storedTimeStamp);
//       },
//       1000 * 60 * logOutTime,
//     );
//   };

//   let warningInactive = (timeString) => {
//     clearTimeout(startTimerInterval.current);

//     warningInactiveInterval.current = setInterval(() => {
//       const maxTime = logOutTime;

//       const diff = moment.duration(moment().diff(moment(timeString)));
//       const minPast = diff.minutes() || 0;
//       if (minPast === maxTime) {
//         clearInterval(warningInactiveInterval.current);
//         sessionStorage.removeItem("lastTimeStamp");
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("assetId");
//         localStorage.removeItem("isAuth");
//         window.location.href = "/login";
//       }
//     }, 1000);
//   };

//   const logOutTime = 30 * 60 * 1000; // 30 minutes in ms
//   const logoutTimer = useRef(null);

//   const resetTimer = useCallback(() => {
//     if (logoutTimer.current) {
//       clearTimeout(logoutTimer.current);
//     }

//     if (token) {
//       logoutTimer.current = setTimeout(() => {
//         sessionStorage.removeItem("lastTimeStamp");
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("assetId");
//         localStorage.removeItem("isAuth");
//         window.location.href = "/login";
//       }, logOutTime);
//     }
//   }, [token]);

//   // let resetTimer = useCallback(() => {
//   //   clearTimeout(startTimerInterval.current);
//   //   clearInterval(warningInactiveInterval.current);

//   //   if (token) {
//   //     timeStamp = moment();
//   //     sessionStorage.setItem("lastTimeStamp", timeStamp);
//   //   } else {
//   //     clearInterval(warningInactiveInterval.current);
//   //     sessionStorage.removeItem("lastTimeStamp");
//   //   }
//   //   timeChecker();
//   // }, [token]);

//   // useEffect(() => {
//   //   events.forEach((event) => {
//   //     window.addEventListener(event, resetTimer);
//   //   });

//   //   timeChecker();

//   //   return () => {
//   //     clearTimeout(startTimerInterval.current);
//   //     resetTimer();
//   //   };
//   // }, [resetTimer, events, timeChecker]);

//   useEffect(() => {
//     const events = ["click", "load", "scroll", "change", "keydown"];

//     events.forEach((event) => {
//       window.addEventListener(event, resetTimer);
//     });

//     resetTimer(); // start timer on mount

//     return () => {
//       if (logoutTimer.current) {
//         clearTimeout(logoutTimer.current);
//       }

//       events.forEach((event) => {
//         window.removeEventListener(event, resetTimer);
//       });
//     };
//   }, [resetTimer]);

//   return token ? <AppRoutes /> : <AuthRoutes />;
// }

// export default App;
import { useSelector } from "react-redux";
import { useEffect, useCallback, useRef } from "react";

import { AuthRoutes, AppRoutes } from "./Routes";

function App() {
  const { token } = useSelector((store) => store.LoginReducer);

  const logoutTime = 30 * 60 * 1000; // 30 minutes
  const logoutTimer = useRef(null);

  const logout = () => {
    sessionStorage.removeItem("lastTimeStamp");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("assetId");
    localStorage.removeItem("isAuth");
    window.location.href = "/login";
  };

  const resetTimer = useCallback(() => {
    if (!token) return;

    if (logoutTimer.current) {
      clearTimeout(logoutTimer.current);
    }

    logoutTimer.current = setTimeout(logout, logoutTime);
  }, [token]);

  useEffect(() => {
    const events = ["click", "mousemove", "keydown"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      if (logoutTimer.current) clearTimeout(logoutTimer.current);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [resetTimer]);

  return token ? <AppRoutes /> : <AuthRoutes />;
}

export default App;
